// extracted by mini-css-extract-plugin
export default {"label":"TextInput_label__m+KU9","input":"TextInput_input__U30a2"};